<template>
  <div class="contact-section">
    <p class="contact-section-header">
      {{ $t('tenancy.table.fireMarshalContacts') }}
    </p>
    <table class="contacts-table">
      <thead>
        <tr class="table-header-height">
          <th
            v-for="(header, index) in headers"
            :key="index"
            :class="header.class"
          >
            {{ header.name }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in contacts"
          :key="index"
          class="table-body-row__height"
        >
          <td class="number-column">
            {{ item.i18nRole | isEmptyValue }}
          </td>
          <td class="number-column">
            <div v-if="canAccessContact">
              <a
                class="name-hyper-link"
                @click="navToContactDetail(item.id, false)"
              >
                {{ item.fullName || item.name }}
              </a>
              <i
                v-if="isEngineer"
                v-show="!!item.remarks"
                class="remark-included-flag"
              />
            </div>
            <div v-else>
              {{ item.fullName || item.name }}
            </div>
          </td>
          <td class="number-column">
            <div> {{ item.phone }}</div>
          </td>
          <td class="number-column">
            <div> {{ item.fEmailsDisplay | isEmptyValue }}</div>
          </td>
          <td class="number-column">
            <div>
              <pre>{{ item.fRemarks | isEmptyValue }}</pre>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { useStoreGetters } from '@/store/index'
import { useFireMarshalContacts, useFireMarshalHeader } from '../hook'
import { useTenancyContactComputes } from '../edit/hook'
import navToContactDetailMixin from '../edit/navToContactDetailMixin'

export default {
  setup () {
    const { isEngineer, isTenant } = useStoreGetters('user', ['isEngineer', 'isTenant'])
    const contacts = useFireMarshalContacts()
    const { canAccessContact } = useTenancyContactComputes()
    const { navToContactDetail } = navToContactDetailMixin.methods
    const headers = useFireMarshalHeader()
    return {
      isTenant,
      isEngineer,
      canAccessContact,
      navToContactDetail,
      headers,
      contacts,
    }
  },
}
</script>
<style lang="scss" scoped>
@import './tenancy-contacts';
</style>
